import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  WritableSignal,
  input,
  linkedSignal,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { SpinnerComponent } from '../spinner/spinner.component';

enum ImageLoadingState {
  Loading,
  Loaded,
  Error,
}

@Component({
  selector: 'mp-image',
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, SpinnerComponent],
})
export class ImageComponent {
  /**
   * Image full path. This value is used directly to fetch the image.
   */
  readonly imagePath: InputSignal<string | null | undefined> = input.required<string | null | undefined>();

  /**
   * The alternative text to display.
   */
  readonly alternateText: InputSignal<string | undefined> = input<string>();

  readonly useScaleDown: InputSignal<boolean> = input<boolean>(true);
  readonly imageLoadError: OutputEmitterRef<void> = output();

  readonly state: WritableSignal<ImageLoadingState> = linkedSignal({
    source: this.imagePath,
    computation: () => ImageLoadingState.Loading,
  });

  readonly ImageLoadingState = ImageLoadingState;

  onImgLoad(): void {
    if (this.state() === ImageLoadingState.Loading) {
      this.state.set(ImageLoadingState.Loaded);
    }
  }

  onImgError(): void {
    this.state.set(ImageLoadingState.Error);
    this.imageLoadError.emit();
  }
}
